export const environment = {
  production: false,
  apiUrl: 'http://localhost:8500',
  apiUrlUaa: 'http://localhost:9999',
  apiUrlCore: 'http://localhost:8501',
  apiUrlMessengerPeople: 'https://api.messengerpeople.dev/templates',
  //apiUrl: 'http://localhost:8500',
  hmr: false,
  GA_TRACKING_ID: 'G-TG42QKQHYH',
  VAPID_PUBLIC_KEY:
    'BPDPEPEMF-GVhPPtGwmYva_szQdTUgFjKIGG8qPJYY87uKRX82Pu47q2FbpOIMVmm1h5vulI24UHUIXbgSn-uR8',
  URL_EXCEL_FILE_MODEL:
    'https://cdn.fromdoppler.com/doppler-conversations/Plantilla_Mensajes_Masivos_Uso_parmetros.xlsx',
  URL_EXCEL_FILE_IMPORT_CONTACT_MODEL:
    'https://cdn.fromdoppler.com/doppler-conversations/Plantilla_Importar_Contactos.xlsx',
  META_APP_ID: '1255668512739720',
  META_APP_LOGIN_CONFIG: '3004181903115309',
  META_SRC_SDK_SCRIPT:
    'https://connect.facebook.net/es_LA/sdk.js#xfbml=1&version={%META_GRAPH_API_VERSION%}&appId={%META_APP_ID%}&autoLogAppEvents=1',
  META_GRAPH_API_VERSION: 'v25.0',
  IS_ENABLED_DEBUG_SOCKETJS: true,
  IS_ENABLED_LOGGING: false,
  URL_BASE_DOPPLER_CONFIGURATION: 'https://appqa.fromdoppler.net',
  WSP_API_CLOUD_REQUEST_ENABLED: false,
  PERMANENT_TOKEN_WSP_BEPLIC: '',
  META_PERMISSION_REQUEST_ENABLED: false,
  INSTAGRAM_REQUEST_ENABLED: false,
  MESSENGER_REQUEST_ENABLED: false,
  URL_DOPPLER: 'https://conversations.qa.fromdoppler.net',
  URL_DOPPLER_MAIN: 'https://webappqa.fromdoppler.net',
  URL_BEPLIC: 'https://conversations.qa.fromdoppler.net',
  DOPPLER_STYLE_ENABLED: false,
  CHATBOT_SCRIPT: 'assets/content/js/qa-beplic-external-chat.js',
  PARTNER_KEY_DOPPLER: 'ef3e19d248a4fd23ccf809835cc1c143',
  PATH_EXTERNAL_LOGIN: 'external-login',
  DOPPLER_STYLE_GUIDE:
    'https://cdn.fromdoppler.com/doppler-style-guide/asset-manifest-main.json',
  DOPPLER_SESSION_MFE:
    'https://cdn.fromdoppler.com/doppler-session-mfe/asset-manifest-main.json',
  DOPPLER_MENU_MFO:
    'https://cdn.fromdoppler.com/doppler-menu-mfe/asset-manifest-main.json',
  BEAMER_ID: 'OKjmyOFa52044',
  DOPPLER_CONVERSATION_IA_AGENTS_MFE_MANIFEST_URL:
    'https://cdn.fromdoppler.com/doppler-conversations-ai-agent-mfe/asset-manifest-main.json',
};
